import Marquee from "react-fast-marquee";

export default function MarqueeStrip({ items, variant = "solid" }) {
    return (
        <div
            className={`py-6 border-y border-white/10 overflow-hidden ${
                variant === "solid" ? "bg-white text-black" : "bg-black"
            }`}
            data-testid="marquee-strip"
        >
            <Marquee speed={50} gradient={false}>
                {items.map((item, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-8 mx-8"
                    >
                        <span
                            className={`font-display text-3xl md:text-5xl uppercase tracking-tight ${
                                variant === "outline"
                                    ? "text-outline"
                                    : ""
                            }`}
                        >
                            {item}
                        </span>
                        <span className="w-2 h-2 bg-current shrink-0" />
                    </div>
                ))}
            </Marquee>
        </div>
    );
}
